import Vue from 'vue'
import Router from 'vue-router'
import TopUp from './views/TopUp.vue'
import TopUps from './views/TopUps.vue'
import Login from './views/Login.vue'
import User from './views/User.vue'
// import Bundles from './views/Bundles.vue'
// import Privacy from './views/Privacy.vue'
// import Terms from './views/Terms.vue'
import Resellers from './views/Resellers.vue'
import Reseller from './views/Reseller.vue'
import Rateplans from './views/Rateplans.vue'
import Rateplan from './views/Rateplan.vue'

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: TopUp,
      meta: { secure: true },
    },
    {
      path: '/secure',
      component: Login,
      meta: { secure: false },
    },
    {
      path: '/secure/rateplans',
      component: Rateplans,
      meta: { secure: true },
    },
    {
      path: '/secure/rateplans/:id',
      component: Rateplan,
      meta: { secure: true },
    },
    {
      path: '/secure/topups-admin',
      component: TopUps,
      meta: { secure: true, allResellers: true },
    },
    {
      path: '/secure/topups',
      component: TopUps,
      meta: { secure: true, allResellers: false },
    },
    {
      path: '/secure/resellers',
      component: Resellers,
      meta: { secure: true },
    },
    {
      path: '/secure/resellers/:id',
      component: Reseller,
      meta: { secure: true },
    },
    {
      path: '/secure/resellers/:id/users/:userId',
      component: User,
      meta: { secure: true },
    },
    // {
    //   path: '/bundles',
    //   name: 'Bundles',
    //   component: Bundles,
    // },
    // {
    //   path: '/privacy',
    //   name: 'Privacy',
    //   component: Privacy,
    // },
    // {
    //   path: '/terms',
    //   name: 'Terms',
    //   component: Terms,
    // },
  ],
})

Vue.use(Router)

export default router
